import _parsePhoneNumber, {
  isValidPhoneNumber as _isValidPhoneNumber,
} from 'libphonenumber-js/core'
import type { MetadataJson, CountryCode } from 'libphonenumber-js/core'

import metadata from './phone-metadata.json'

export function parsePhoneNumber(text: string, countryCode?: CountryCode) {
  if (!countryCode) {
    return _parsePhoneNumber(text, metadata as unknown as MetadataJson)
  }

  return _parsePhoneNumber(text, countryCode, metadata as unknown as MetadataJson)
}

export function isValidPhoneNumber(text: string, countryCode: CountryCode) {
  return _isValidPhoneNumber(text, countryCode, metadata as unknown as MetadataJson)
}
